<template>
    <!-- 营销管理－新增优惠券 -->
    <content-view class="new-coupon">
        <div class="new-coupon-tab">
            <a-tabs type="card" :activeKey="activeKey" :animated="false" @change="changeTab">
                <a-tab-pane tab="优惠券类型" :key="1"></a-tab-pane>
                <a-tab-pane tab="优惠券规则" :key="2"></a-tab-pane>
            </a-tabs>
        </div>
        <a-form :form="form">
            <div ref="couponDetail" class="couponDetail">
                <a-card class="mb24" title="优惠券类型" :bordered="false">
                    <a-form-item v-bind="formItemLayout" label="优惠券名称">
                        <a-input
                        style="width: 67%"
                        :disabled="isDisable"
                        placeholder="请输入"
                        v-decorator="['name',{rules: [{ required: true, message: '优惠券名称!', whitespace: true }]}]"
                        />
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="优惠券名称(英文)">
                        <a-input
                        style="width: 67%"
                        :disabled="isDisable"
                        placeholder="请输入"
                        v-decorator="['englishName',{rules: [{message: '优惠券名称(英文)!', whitespace: true }]}]"
                        />
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="优惠券适用类型">
                        <a-radio-group :disabled="isDisable" v-decorator="['suitType',{initialValue: 1}]" @change="onChangeType1" >
                            <a-radio :value="1">门票</a-radio>
                            <a-radio :value="2">餐饮</a-radio>
                            <a-radio :value="3">零售</a-radio>
                            <a-radio :value="4">课程</a-radio>
                            <a-radio :value="10">租赁</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="是否在积分商城售卖">
                        <a-radio-group :disabled="isDisable" v-decorator="['isShowMall', {initialValue: 1, rules: [{ required: true}]}]">
                            <a-radio :value="1">是</a-radio>
                            <a-radio :value="0">否</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="suitType === 1" v-bind="formItemLayout" label="适用门票范围">
                        <a-radio-group :disabled="isDisable" v-decorator="['suitTicket',{initialValue: 1}]" @change="onChangeType2" >
                            <a-radio :value="1">线上售卖</a-radio>
                            <a-radio :value="2">门店售卖</a-radio>
                            <a-radio :value="3">全部门票</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="suitType !== 1" v-bind="formItemLayout" label="适用门店范围">
                        <a-radio-group :disabled="isDisable" v-decorator="['shopRange',{initialValue: 1}]" @change="onChangeType3" >
                            <a-radio :value="1">全部门店适用</a-radio>
                            <a-radio :value="2">部分门店适用</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="suitType !== 1 && shopRange === 2" v-bind="formItemLayout" label="门店选择">
                        <a-select
                        :disabled="isDisable"
                        placeholder="请选择(可多选)"
                        mode="multiple"
                        @change="changeSuitShop"
                        v-decorator="['suitShopIds',{rules: [{required: suitType !== 1 && shopRange === 2, message: '请选择',}]}]"
                        >
                            <a-select-option :value="item.id" v-for="item in shopList" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item v-show="suitType === 1 && suitTicket === 1" v-bind="formItemLayout" label="适用票券">
                        <a-radio-group :disabled="isDisable" v-decorator="['ticketRange',{initialValue: 1}]" @change="onChangeType4" >
                            <a-radio :value="1">全部线上售卖票券适用</a-radio>
                            <a-radio :value="2">部分线上售卖票券适用</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <template v-show="suitType == 1 && suitTicket == 1 && ticketRange == 2">
                        <a-form-item v-bind="formItemLayout" label=" " :colon="false" v-show="suitType === 1 && suitTicket === 1 && ticketRange === 2">
                            <a-button v-if="!ticketIds.length" :disabled="isDisable" type="primary" @click="toSelectTicket(-1)">选择票券</a-button>
                            <template v-else>
                                <span>您共选择了{{ticketIds.length}}张票</span> <a-button class="ml16" :disabled="isDisable" type="primary" @click="goodsLimitDelete(-1)">删除</a-button>
                            </template>
                        </a-form-item>
                        <a-form-item label=" " :colon="false" v-bind="formItemLayout" v-show="ticketIds.length && suitType === 1 && suitTicket === 1 && ticketRange === 2">
                            <a-table :scroll="{ x: 700 }" bordered :columns="columnsTicket" :dataSource="dataSourceTicket" :rowKey="record => record.ticketTemplateId" >
                                <span slot="type" slot-scope="a">{{['', '期限卡', '次卡'][a]}}</span>
                                <template slot="action" slot-scope="a,row">
                                    <span v-if="isDisable" class="text-disabled">删除</span>
                                    <a v-else class="text-primary" @click="deleteData(-1, row.ticketTemplateId)">删除</a>
                                </template>
                            </a-table>
                        </a-form-item>
                    </template>
                    <a-row>
                        <a-col :span="4"></a-col>
                        <a-col :span="16">
                            <div v-show="suitType === 1 && suitTicket === 2" v-for="(item, index) in suitShopList" :key="index" class="suit-shop pt24">
                                <div class="operat" v-if="!isDisable">
                                    <a class="text-primary" @click="addSuitShop">新增 </a>
                                    <a class="text-primary" v-if="usableSuitShopListLength > 1" @click="deleteSuitShop(index)">删除</a>
                                </div>
                                <a-form-item :labelCol="{span: 5}" :wrapperCol="{span: 17}" :label="'适用门店'+(index + 1)" required>
                                    <a-select
                                    :disabled="isDisable"
                                    placeholder="请选择"
                                    @change="onChangeShop($event,index)"
                                    v-model="item.shopId"
                                    >
                                        <a-select-option :value="items.id" v-for="items in shopList" :key="items.id">{{items.name}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                                <a-form-item :labelCol="{span: 5}" :wrapperCol="{span: 19}" :label="'适用票券'+(index + 1)">
                                    <a-radio-group :disabled="isDisable" v-model="item.ticketRange" @change="onChangeType5($event,index)" >
                                        <a-radio :value="1">所有该门店票券适用</a-radio>
                                        <a-radio :value="2">部分该门店票券适用</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                                <a-form-item v-show="item.ticketRange == 2" :labelCol="{span: 5}" :wrapperCol="{span: 17}" :label="'门店票券选择'+(index + 1) + '：'" required>
                                    <a-button v-if="!item.ticketIds.length" :disabled="isDisable" type="primary" @click="toSelectTicket(index)">选择票券</a-button>
                                    <template v-else>
                                        <span>您共选择了{{item.ticketIds.length}}张票</span> <a-button class="ml16" :disabled="isDisable" type="primary" @click="goodsLimitDelete(index)">删除</a-button>
                                    </template>
                                </a-form-item>
                                <a-form-item label=" " :colon="false" v-bind="formItemLayout" v-show="item.ticketIds.length && item.ticketRange == 2">
                                    <a-table style="width: 110%" :scroll="{ x: 700 }" bordered :columns="columnsTicket" :dataSource="item.selectTicket" :rowKey="record => record.ticketTemplateId" >
                                        <span slot="type" slot-scope="a">{{['', '期限卡', '次卡'][a]}}</span>
                                        <template slot="action" slot-scope="a,row">
                                            <span v-if="isDisable" class="text-disabled">删除</span>
                                            <a v-else class="text-primary" @click="deleteData(index, row.ticketTemplateId)">删除</a>
                                        </template>
                                    </a-table>
                                </a-form-item>
                            </div>
                        </a-col>
                    </a-row>
                    <a-form-item class="mt8" style="margin-bottom: 0" v-bind="formItemLayout" label="优惠券接收展示图" required>
                        <image-uploader :disabled="!(isEdit || isAdd)" ref="uploader" :value="imgUrl" @uploaded="uploaded"></image-uploader>
                    </a-form-item>
                </a-card>
            </div>
            <div ref="couponDetail" class="couponDetail">
                <a-card class="step-two mb24" ref="couponDetail" title="优惠券规则" :bordered="false">
                    <a-form-item v-bind="formItemLayout" label="优惠券类型">
                        <a-radio-group :disabled="isDisable" v-decorator="['couponType',{initialValue: 1}]" @change="onChangeType6">
                            <a-radio :value="1">满减券</a-radio>
                            <a-radio :value="2">折扣券</a-radio>
                            <a-radio :value="3" v-show="suitType == 2">兑换券</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-row v-show="couponType !== 3">
                        <a-col :span="10">
                            <a-form-item :labelCol="{span: 10}" :wrapperCol="{span: 10}" :required="true" label="优惠券使用规则">
                                <a-radio-group :disabled="isDisable" v-model="threshold" @change="onChangeRequired">
                                    <a-radio :value="1">有门槛</a-radio>
                                    <a-radio :value="0">无门槛</a-radio>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="3" style="margin-left: -30px" v-if="threshold == 1">
                            <a-form-item :labelCol="{span: 1}" :wrapperCol="{span: 23}" label="" :colon="false">
                                <span>满
                                    <a-input-number style="width:80px" :min="0" v-decorator="['fullAmount', {rules: [{required: threshold == 1 && couponType !== 3, message: '请输入'}, {pattern: /^(\d{1,8})([.]{1}\d{1,2})?$/, message: '请输入大于0的数, 且保留2位小数'}]}]" placeholder :disabled="isDisable"/>
                                </span>
                            </a-form-item>
                        </a-col>
                        <a-col :span="4" style="margin-left: -40px" v-if="couponType == 1">
                            <a-form-item :labelCol="{span: 1}" :wrapperCol="{span: 23}" label="" :colon="false">
                                <span>减
                                    <a-input-number style="width:100px" :min="0" v-decorator="['reduceAmount', {rules: [{required: couponType == 1 && couponType !== 3, message: '请输入'}, {pattern: /^(\d{1,8})([.]{1}\d{1,2})?$/, message: '请输入大于0的数, 且保留2位小数'}]}]" placeholder :disabled="isDisable"/>(元)
                                </span>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8" style="margin-left: -40px" v-if="couponType == 2">
                            <a-form-item :labelCol="{span: 1}" :wrapperCol="{span: 23}" label="" :colon="false">
                                <span>打
                                    <a-input-number style="width:100px" :min="0.1" :max="9.9" v-decorator="['discountRate', {rules: [{required: couponType == 2 && couponType !== 3, message: '请输入'}]}]" placeholder :disabled="isDisable"/>折 ({{form.getFieldValue("discountRate") ? (form.getFieldValue("discountRate") * 10).toFixed(2) : 0}}%)
                                    <!-- <a-input-number style="width:100px" :min="0.1" :max="9.9" v-decorator="['discountRate', {rules: [{pattern: /^(\d{1})([.]{1}\d{1})?$/, message: '请输入大于0的数, 且保留1位小数'}]}]" placeholder :disabled="isDisable"/>折 ({{form.getFieldValue("discountRate") ? (form.getFieldValue("discountRate") * 10).toFixed(2) : 0}}%) -->
                                </span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-alert style="width: 700px;" v-if="form.getFieldValue('suitType') == 10" class="mb24 ml80" message="租赁优惠券不对押金有效，仅对收银台租赁商品有效。即：押金按实际付和退，收银台租赁商品按优惠券计算优惠价格。" />
                    <a-form-item v-bind="formItemLayout" label="优惠券数量">
                        <a-input-number
                        style="width: 67%"
                        placeholder="'-1'表示不限制"
                        :min="-1"
                        :precision="0"
                        :disabled="isDisable"
                        v-decorator="[
                            'num',
                            {rules: [{ required: true, message: '请输入优惠券数量'}]}
                        ]"
                        />
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="生效时间" required>
                        <a-radio-group @change="onChangeTime" v-decorator="['dateType',{initialValue: 0}]" :disabled="isDisable">
                            <div class="mb16">
                                <a-radio :disabled="isDisable" :value="0">
                                    指定有效天数
                                    <span>
                                        自获得日期起，有效期
                                        <a-input-number style="width: 100px" :disabled="isShowValidDates || isDisable" v-decorator="['validDates']" :min="1" :step="1" /> 天
                                    </span>
                                </a-radio>
                            </div>
                            <div>
                                <a-radio :disabled="isDisable" :value="1">
                                    指定日期
                                    <span>
                                        <a-range-picker
                                            style="width: 280px"
                                            :disabled="!isShowValidDates || isDisable"
                                            showTime
                                            @change="onChangePicker"
                                            format="YYYY-MM-DD HH:mm:ss"
                                            v-decorator="['rangePicker']"
                                        />
                                    </span>
                                </a-radio>
                            </div>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="是否优惠某个餐品" v-show="suitType == 2 && couponType != 3">
                        <a-radio-group :disabled="isDisable" v-decorator="['isDisCateringGoods',{initialValue: 0}]">
                            <a-radio :value="0">否</a-radio>
                            <a-radio :value="1">是</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <div v-show="(form.getFieldValue('isDisCateringGoods') == 1 || couponType == 3)&& suitType == 2">
                        <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 20}" label="适用门店商品" required></a-form-item>
                        <a-row>
                            <a-col :span="2"></a-col>
                            <a-col :span="22">
                                <a-table :dataSource="useShopList" :columns="columns" bordered :pagination="false" :rowKey="(item, index) => index">
                                    <template slot="name" slot-scope="name, row">{{name || row.shopName}}</template>
                                    <template slot="suitRetail" slot-scope="suitRetail, row">
                                        <span v-if="row.suitGoodsDesc">{{row.suitGoodsDesc}}</span>
                                        <span v-else>{{suitRetail.length ? suitRetail[0].dishName + "等" + suitRetail.length + "件商品" : "暂无商品"}}</span>
                                    </template>
                                    <template slot="action" slot-scope="key, row">
                                        <template v-if="row.suitRetail.length">
                                            <a class="text-primary" @click="openMealList('check', row)">查看商品</a>
                                            <a-divider type="vertical" />
                                        </template>
                                        <a class="text-primary" @click="openMealList('add', row)">添加商品</a>
                                        <a-divider type="vertical" v-if="row.suitRetail.length"/>
                                        <template v-if="row.suitRetail.length">
                                            <a class="text-primary"  @click="openMealList('delete', row)">删除商品</a>
                                        </template>
                                    </template>
                                </a-table>
                            </a-col>
                        </a-row>
                    </div>
                </a-card>
            </div>
        </a-form>
        <a-card class="text-center">
            <a-button @click="$router.go(-1)">返回</a-button>
            <a-button @click="handleSubmit" type="primary" v-if="!isDisable || isEdit" :loading="loading" >保存</a-button>
        </a-card>
        <!-- 适用门店选择 -->
        <a-modal
        centered
        title="选择门店"
        :width="800"
        :visible="isAddNewShop"
        :maskClosable="false"
        @cancel="selectShopCancel"
        @ok="selectShopConfirm"
        >
            <div class="font-weight font-big mb16 text-color-85">
                <a-select allowClear v-model="currentCity" :options="cityList" placeholder="请选择" style="width: 300px;"></a-select>
            </div>
            <a-table
            style="word-break:break-all;"
            bordered
            :pagination="false"
            :scroll="{y: 400}"
            :columns="shopSelectColumns"
            :rowSelection="{type: 'checkbox', onChange: shopSelectChange, onSelectAll: shopSelectAll, selectedRowKeys: shopSelectedRowKeys}"
            :dataSource="filtedShopList"
            :rowKey="item => item.id"
            >
            <template slot="address" scope="key, row">{{row.city + row.address}}</template>
            </a-table>
        </a-modal>
        <ticket-picker goodType="ticket" ref="ticketPicker" :ticketList="selectTicket" @confirmSelectTicket='confirmSelectTicket'></ticket-picker>
        <menu-list ref="menuList" :menuDailogType="menuDailogType" @deleteMealList="deleteMealList" @addMealList="addMealList"></menu-list>
    </content-view>
</template>

<script type="text/javascript">
import ImageUploader from '@/components/common/image-uploader.component';
import menuList from "@/components/modules/change-code/menu-list.component";
import ticketPicker from "@/components/modules/platform/tickets-picker.component"
export default {
    name: "ticket",
    props: {},
    data() {
        const columnsTicket = [
            {
                title: "票券ID",
                dataIndex: "ticketTemplateId",
                width: 80
            },
            {
                title: "票券内部标识",
                dataIndex: "name",
            },
            {
                title: "票券类型",
                dataIndex: "type",
                scopedSlots: { customRender: "type" },
                width: 100
            },
            {
                title: "售卖价/元",
                dataIndex: "sellShowPrice",
                width: 100
            },
            {
                title: "操作",
                dataIndex: "action",
                scopedSlots: { customRender: "action" },
                width: 80
            }
        ];
        const columns = [
            {
                title: '门店名称',
                dataIndex: 'name',
                scopedSlots: {
                    customRender: 'name'
                }
            },
            {
                title: '适用商品',
                dataIndex: 'suitRetail',
                scopedSlots: {
                    customRender: 'suitRetail'
                }
            },
            {
                title: '操作',
                dataIndex: 'action',
                width: "45%",
                scopedSlots: {
                    customRender: 'action'
                }
            },
        ];
        const shopSelectColumns = [
            {
                title: '门店名称',
                dataIndex: 'name',
                width: "35%"
            },
            {
                title: '门店地址',
                dataIndex: 'address',
                scopedSlots: {
                    customRender: 'address'
                }
            }
        ];
        return {
            columns,
            columnsTicket,
            shopSelectColumns,
            dataSourceTicket: [],
            goodsLimitSelectedDeleteRowKeys: [],
            isAddNewShop: false,
            id: undefined,
            activeKey: 1,
            scrollLock: false,
            formItemLayout: {
                labelCol: {
                    span: 4
                },
                wrapperCol: {
                    span: 16
                }
            },
            isDisable: false,
            isEdit: false,
            imgUrl: '',
            couponType: 1,
            suitType: 1,
            suitTicket: 1,
            shopRange: 1,
            ticketRange: 1,
            suitShopList: [{
                ticketRange: 1,
                shopId: undefined,
                selectTicket: [],
                ticketIds: [],
                ticketList2: [],
            }],
            ticketIds: [],
            selectTicket: [],
            selectTicketType: 0,
            threshold: 1,
            isShowValidDates: false,
            // isShowSendTime: false,
            ticketList: [],
            cityList: [],
            filtedShopList: [],
            shopList: [],
            useShopList: [],
            currentCity: undefined,
            shopSelectedRowKeys: [],
            shopSelectedRows: [],
            loading: false,
            curSuitShopList: [],
            menuDailogType: "",
            menuDailogShops: {},
            isAdd: false,
        };
    },
    components: {
        ImageUploader,
        menuList,
        ticketPicker,
    },
    computed: {
        usableSuitShopListLength() {
            return this.suitShopList.length;
        }
    },
    watch: {
        'shopList'(val) {
            if (this.id) {
                this.getCouponsDetail(this.id);
                this.columns = [{
                    title: '门店名称',
                    dataIndex: 'name',
                    scopedSlots: {
                        customRender: 'name'
                    }
                },
                {
                    title: '适用商品',
                    dataIndex: 'suitRetail',
                    scopedSlots: {
                        customRender: 'suitRetail'
                    }
                },]
            }
            if(this.$route.name == 'newCoupon') {
                this.isAdd = true;
            }
            if(this.$route.name == 'newCouponEdit') {
                this.isEdit = true;
            }
        },
        currentCity(val, oval) {
            if (val) {
                this.filtedShopList = this.shopList.filter(i => i.city === val);
            } else {
                this.filtedShopList = this.shopList;
            }
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    beforeDestroy() {
        this.scrollEl.removeEventListener('scroll', this.scrollEvent);
    },
    mounted() {
        this.id = this.$route.query.id
        this.getShopList();
        this.getCityList();
        this.scrollEl = document.getElementsByClassName('main-container-cover')[0];
        this.targetEl = document.getElementsByClassName('couponDetail');
        this.scrollEl.addEventListener('scroll', this.scrollEvent);
    },
    methods: {
        /**
        * @goodsLimitDelete 优惠券使用限制商品删除选中的
            */
        goodsLimitDelete(type) {
            if (!this.goodsLimitSelectedDeleteRowKeys.length) {
                this.$message.warning("请选择票券")
                return;
            }
            if (type === -1) {
                this.dataSourceTicket = this.dataSourceTicket.filter((i) => {
                    return !Boolean(this.goodsLimitSelectedDeleteRowKeys.find(item => String(item) === String(i.ticketTemplateId)));
                });
                this.ticketIds = this.dataSourceTicket.map(el => el.ticketTemplateId);
            } else {
                this.suitShopList[type].selectTicket = this.suitShopList[type].selectTicket.filter((i) => {
                    return !Boolean(this.goodsLimitSelectedDeleteRowKeys.find(item => String(item) === String(i.ticketTemplateId)));
                });
                this.suitShopList[type].ticketIds = this.suitShopList[type].selectTicket.map(el => el.ticketTemplateId);
            }
            this.goodsLimitSelectedDeleteRowKeys = [];
        },
        deleteData(type, id) {
            if (type == -1) {
                this.dataSourceTicket = this.dataSourceTicket.filter(item => item.ticketTemplateId != id);
                this.ticketIds = this.dataSourceTicket.map(el => el.ticketTemplateId);
            } else {
                this.suitShopList[type].selectTicket = this.suitShopList[type].selectTicket.filter(item => item.ticketTemplateId != id);
                this.suitShopList[type].ticketIds = this.suitShopList[type].selectTicket.map(el => el.ticketTemplateId);
            }
        },
        /**
        * @goodsLimitOnchange 优惠券使用限制表格选择变更事件
            */
        goodsLimitOnchange(selectedRowKeys, selectedRows) {
            this.goodsLimitSelectedDeleteRowKeys = selectedRowKeys;
        },
        confirmSelectTicket(ticket) {
            let ticketIds = ticket.map(el => el.ticketTemplateId);
            if (this.selectTicketType == -1) {
                this.ticketIds = ticketIds;
                this.dataSourceTicket = ticket;
            } else {
                this.suitShopList[this.selectTicketType].ticketIds = ticketIds;
                this.suitShopList[this.selectTicketType].selectTicket = ticket;
            }
        },
        toSelectTicket(type) {
            if (type == -1) {
                this.selectTicket = this.ticketList;
            } else {
                if (!this.suitShopList[type].shopId) {
                    this.$message.warning("请先选择门店");
                    return;
                }
                this.selectTicket = this.suitShopList[type].ticketList2;
            }
            this.selectTicketType = type;
            this.$refs.ticketPicker.visible = true;
        },
        changeSuitShop(event) {
            let useShopList = [];
            event.forEach(el => {
                let repeatShop = this.useShopList.find(item => item.id == el);
                let shop = this.shopList.find(item => item.id == el);
                if (!repeatShop) {
                    useShopList.push(this.$utils.deepClone(shop))
                } else {
                    useShopList.push(this.$utils.deepClone(repeatShop))
                }
            });
            this.useShopList = useShopList;
        },
        deleteShops(index) {
            this.useShopList.splice(index, 1)
        },
        addMealList(meals) {
            this.$refs.menuList.visible = false;
            this.useShopList.forEach(el => {
                if (el.id === this.menuDailogShops.id) {
                    el.suitRetail = meals;
                }
            });
            this.$message.success("添加成功");
            this.menuDailogType = "";
            this.menuDailogShops = {};
        },
        deleteMealList(meals) {
            this.$refs.menuList.visible = false;
            this.useShopList.forEach(el => {
                if (el.id === this.menuDailogShops.id) {
                    let suitRetail = el.suitRetail.filter(item => {
                        return !meals.find($item => $item.dishId == item.dishId)
                    });
                    el.suitRetail = this.$utils.deepClone(suitRetail)
                }
            });
            this.$message.success("删除成功");
            this.menuDailogType = "";
            this.menuDailogShops = {};
        },
        openMealList(type, shop) {
            this.$refs.menuList.resetTable();
            if (type != "add") {
                this.$refs.menuList.menuDailogShops = shop;
                this.$refs.menuList.dataSource = shop.suitRetail;
            } else {
                this.$refs.menuList.search(shop);
            }
            this.menuDailogType = type;
            this.menuDailogShops = shop;
            this.$refs.menuList.visible = true;
        },
        getCityList() {
            this.$api.totalPlatform.cityList({}).then(res => {
                this.cityList = res.map(item => {
                    return ({
                        label: item,
                        value: item
                    });
                })
            });
        },
        selectShopConfirm() {
            this.isAddNewShop = false;
            const useShopListSave = this.$utils.deepClone(this.useShopList);
            let useShopList = this.shopSelectedRows.filter(el => {
                Object.assign(el, {
                    suitRetail: [],
                })
                return !this.useShopList.find(item => item.id == el.id)
            });
            this.useShopList = [...useShopListSave, ...useShopList];
        },
        /**
         * @selectShopCancel 场地选择确定取消
         */
        selectShopCancel() {
            this.isAddNewShop = false;
            setTimeout(() => {
                this.shopSelectedRowKeys = [];
                this.shopSelectedRows = [];
                this.currentCity = undefined;
                this.filtedShopList = this.shopList;
            }, 300);
        },
        /**
         * @shopSelectChange 场地选择
         */
        shopSelectChange(selectedRowKeys, selectedRows) {
            this.shopSelectedRowKeys = selectedRowKeys;
            this.shopSelectedRows = selectedRows;
        },
        /**
         * @shopSelectAll 场地全选
         */
        shopSelectAll(val, selectedRows) {
            this.shopSelectedRowKeys = selectedRows.map(i => i.id);
        },
        openSelectedShop() {
            this.shopSelectedRowKeys = this.useShopList.map(i => i.shopId);
            this.isAddNewShop = true;
        },
        /**
         * @scrollEvent 滚动回调
         */
        scrollEvent(e) {
            if (this.scrollLock) {
                return false;
            }
            let currentValue = e.target.scrollTop;
            let targetValueMap = Array.prototype.map.call(this.targetEl, (i) => (i.offsetTop + 100));
            let activeKey = 1;
            targetValueMap.forEach((item, index) => {
                if (currentValue > item) {
                    activeKey = index + 1;
                }
            });
            this.activeKey = activeKey;
        },
        /**
         * @changeTab tab点击回调
         */
        changeTab(val) {
            let targetValueMap = Array.prototype.map.call(this.targetEl, (i) => (i.offsetTop + 100));
            this.activeKey = val;
            this.scrollLock = true;
            this.scrollEl.scrollTop = targetValueMap[val - 1];
            setTimeout(() => {
                this.scrollLock = false;
            }, 100);
        },
        // 系统票券获取
        getTicket(lineType, shopId) {
            this.$api.totalPlatform.getTotalTicketList({
                body: {
                    sellShopId: lineType == 2 || lineType == 3 ? shopId : undefined,
                    isMiniSell: lineType == 1 ? true : undefined,
                    isCounterSell: lineType == 2 ? true : undefined,
                }
            }).then(res => {
                if (!res) return;
                res.forEach( el => {
                    el.label = el.name;
                    el.value = el.ticketTemplateId;
                });
                this.ticketList = res || [];
                this.dataSourceTicket = res.filter(el => this.ticketIds.find(item => item == el.ticketTemplateId));
            });
        },
        // 系统票券获取
        getTicket2(lineType, shopId, index) {
            this.$api.totalPlatform.getTotalTicketList({
                body: {
                    sellShopId: lineType == 2 || lineType == 3 ? shopId : undefined,
                    isMiniSell: lineType == 1 || lineType == 3 ? true : undefined,
                    isCounterSell: lineType == 2 || lineType == 3 ? true : undefined,
                }
            }).then(res => {
                if (!res) return;
                res && res.forEach( el => {
                    el.ticketName = el.name;
                    el.ticketId = el.ticketTemplateId;
                    el.value = el.ticketTemplateId;
                    el.label = el.name;
                })
                this.suitShopList[index].ticketList2 = res || [];
                this.suitShopList[index].selectTicket = res.filter(el => this.suitShopList[index].ticketIds.find(item => el.ticketTemplateId == item));
            });
        },
        // 系统店铺获取
        getShopList() {
            this.$api.totalPlatform.selectList({}).then(res => {
                res.forEach(el => {
                    el.label = el.name;
                    el.value = el.id;
                    el.id = el.id * 1;
                    let key = el.id;
                    el.suitRetail = [];
                });
                this.useShopList = res;
                this.filtedShopList = res;
                this.shopList = res;
            });
        },
        onChangeShop(event, index) {
            //判断门店方案不能重复
            let hasRepeatShop = this.suitShopList.filter(item => item.shopId === event);
            if (hasRepeatShop.length > 1) {
                this.suitShopList.splice(index, 1, {
                    ticketRange: 1,
                    shopId: undefined,
                    ticketIds: [],
                    ticketList2: [],
                    selectTicket: [],
                })
                this.$message.error('适用门店不能重复！');
                return false;
            }
            this.getTicket2(2, event, index)
        },
        addSuitShop() {
            this.suitShopList.push(
                {
                    ticketRange: 1,
                    shopId: undefined,
                    ticketIds: [],
                    ticketList2: [],
                    selectTicket: [],
                }
            );
        },
        deleteSuitShop(index) {
            this.suitShopList.splice(index, 1);
        },
        onChangeType1(e) {
            this.suitType = e.target.value;
            this.shopRange = 1;
            this.form.resetFields(['suitShopIds', 'shopRange', "ticketRange", "ticketIds"]);
            this.curSuitShopList = []
        },
        onChangeType2(e) {
            this.suitTicket = e.target.value;
            this.getTicket(e.target.value)
        },
        onChangeType3(e) {
            this.shopRange = e.target.value
            if (this.shopRange == 1 && this.suitType == 2) {
                this.useShopList = this.$utils.deepClone(this.shopList);
            } else {
                this.form.resetFields(["suitShopIds", "ticketRange"]);
                this.useShopList = [];
            }
            this.$nextTick(() => {
                this.form.validateFields(['suitShopIds', 'ticketRange'], { force: true });
            })
        },
        onChangeType4(e) {
            this.ticketRange = e.target.value
            this.getTicket(1,'')
            this.ticketIds = [];
        },
        onChangeType5(event,index) {
            this.suitShopList[index].ticketRange = event.target.value
        },
        onChangeType6(e) {
            this.couponType = e.target.value
            this.form.resetFields(["fullAmount", "reduceAmount", "discountRate"]);
            if (this.couponType == 3) {
                this.threshold = 0;
            }
        },
        uploaded(val) {
            this.imgUrl = val
        },
        // 切换有无门槛
        onChangeRequired() {
            this.form.resetFields(["fullAmount", "reduceAmount", "discountRate"])
        },
        onChangePicker(value, data) {
            this.validStartTime = data[0];
            this.validEndTime = data[1];
        },
        // 切换生效时间类型
        onChangeTime(e) {
            this.isShowValidDates = e.target.value === 1
            this.$nextTick(() => {
                this.form.setFieldsValue({['validDates']: '',['rangePicker']: []});
                this.form.validateFields(['validDates','rangePicker'], { force: true });
            })
        },
        handleSubmit() {
            this.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    if(this.suitType !== 1 && this.shopRange === 2 && !this.form.getFieldValue('suitShopIds')) {
                        this.form.validateFields(['suitShopIds'], { force: true });
                        if(!this.form.getFieldValue('suitShopIds')) {
                            return false
                        }
                    }
                    //判断门店方案不能重复
                    for(let i = 0; i < this.suitShopList.length; i++) {
                        let hasRepeatShop = this.suitShopList.filter(item => item.shopId === this.suitShopList[i].shopId);
                        if (hasRepeatShop.length > 1) {
                            this.$message.error('适用门店不能重复！');
                            return false;
                        }
                    }
                    if(this.suitType === 1 && this.suitTicket === 2) {
                        let flag = false
                        this.curSuitShopList = this.$utils.deepClone(this.suitShopList)
                        this.curSuitShopList.forEach((item,index) => {
                            delete item.selectTicket;
                            delete item.ticketList2
                            if(!item.shopId) {
                                this.$message.error('请选择适用门店'+(index + 1))
                                flag = true
                            }
                            if(item.ticketRange === 2 && (!item.ticketIds || !item.ticketIds.length)) {
                                this.$message.error('请选择门店票券'+(index + 1))
                                flag = true
                            }
                            if (item.ticketIds) {
                                item.ticketIds = item.ticketIds.join(',')
                            }
                        })
                        if(flag) return false
                    }
                    if(!this.imgUrl) {
                        this.$message.error('请选择优惠券接收展示图')
                        return false
                    }
                    var cateringCouponShopGoodsVos;
                    if (this.isShowValidDates) {
                        if(values.rangePicker.length == 0) {
                            this.$message.error('请选择指定有效期')
                            return false
                        }
                    } else {
                        if(!values.validDates) {
                            this.$message.error('请输入有效期天数')
                            return false
                        }
                    }
                    delete values.rangePicker;
                    if (values.suitShopIds) {
                        values.suitShopIds = values.suitShopIds.join(',');
                    }
                    if (values.suitType === 1 && values.suitTicket === 1 && values.ticketRange === 2) {
                        if (!this.ticketIds.length) {
                            this.$message.error('请选择线上票券')
                            return;
                        };
                        values.ticketIds = this.ticketIds.join(',');
                    }
                    if (values.couponType == 3) {
                        values.isDisCateringGoods = 1;
                    }
                    if (this.useShopList.length && (this.suitType == 2 && (values.isDisCateringGoods == 1 || this.couponType == 3))) {
                        var isHasEmptyShop = 0;
                        cateringCouponShopGoodsVos = []
                        this.useShopList.forEach(el => {
                            if (el.suitRetail.length == 0) isHasEmptyShop ++;
                            let suitRetails = el.suitRetail.map(item => {
                                return {
                                    goodsCategory: item.dishCateName,
                                    goodsId: item.dishId,
                                    goodsName: item.dishName,
                                    shopId: el.id,
                                    shopName: el.name,
                                }
                            })
                            cateringCouponShopGoodsVos = [...cateringCouponShopGoodsVos, ...suitRetails]
                        });
                        if (isHasEmptyShop > 0) {
                            this.$message.warning("有未添加适用商品的门店，请先添加再保存")
                            return
                        }
                    }
                    this.loading = true;
                    this.$api.changeCode[this.isEdit ? 'newCouponEdit' : 'newCouponAdd']({
                        body: {
                            ...values,
                            id: this.id,
                            cateringCouponShopGoodsVos,
                            shopList: this.curSuitShopList,
                            imgUrl: this.imgUrl,
                            discountRate: (!Boolean(values.discountRate) && Number(values.discountRate) !== 0) ? undefined :  this.$utils.toFixed(values.discountRate/10, 2),
                            threshold: this.threshold,
                            validEndTime: this.validEndTime,
                            validStartTime: this.validStartTime,
                        }
                    })
                    .then(res => {
                        this.$router.go(-1)
                        this.$message.success("操作成功");
                        this.loading = false
                    })
                    .catch(err => {
                        this.loading = false
                    })
                }
            });
        },

        // 查看详情--获取优惠券详情
        getCouponsDetail(id) {
            this.$api.changeCode
            .newCouponDetail({
                params: {id: id}
            }).then(res => {
                this.isDisable = true;
                let valuesForm = {
                    name: res.name,
                    englishName: res.englishName,
                    suitType: res.suitType,
                    suitTicket: res.suitTicket,
                    shopRange: res.shopRange,
                    suitShopIds: res.suitShopIds ? res.suitShopIds.split(',').map(Number) : [],
                    ticketRange: res.ticketRange,
                    couponType: res.couponType,
                    num: res.num,
                    dateType: res.dateType,
                    fullAmount: res.fullAmount,
                    reduceAmount: res.reduceAmount,
                    isDisCateringGoods: res.isDisCateringGoods,
                    discountRate: (res.discountRate * 10).toFixed(2),
                    isShowMall: res.isShowMall,
                };
                (res.validStartTime && res.validEndTime) && (valuesForm.rangePicker = [this.$moment(res.validStartTime,'YYYY-MM-DD HH:mm:ss'),this.$moment(res.validEndTime,'YYYY-MM-DD HH:mm:ss')])
                valuesForm.validDates = res.dateType === 0 ? res.validDates : undefined

                res.shopSuitList && res.shopSuitList.length > 0 && res.shopSuitList.forEach((item,index) => {
                    item.id = item.shopId * 1;
                    item.shopId = item.shopId * 1;
                    item.ticketList2 = [];
                    item.selectTicket = [];
                    item.ticketIds = item.ticketIds.split(',').map(item => String(item));
                    this.getTicket2(2, item.shopId, index);
                });
                if (res.suitShopDishDescVos && res.suitShopDishDescVos.length) {
                    this.useShopList = res.suitShopDishDescVos;
                };

                this.ticketIds = res.ticketIds ? res.ticketIds.split(',').map(Number) : [],
                this.getTicket(1,'');

                this.couponType = res.couponType;
                this.suitShopList = res.shopSuitList ? res.shopSuitList : [];
                this.suitType = res.suitType;
                this.shopRange = res.shopRange;
                this.suitTicket = res.suitTicket;
                this.ticketRange = res.ticketRange;

                this.threshold = res.threshold;
                this.imgUrl = res.imgUrl;

                this.$nextTick(() => {
                    this.form.setFieldsValue(valuesForm)
                })

            })
        },
    }
};
</script>
<style lang="scss">
.new-coupon {
    &-title {
        color: #000;
        font-size: 16px;
        font-weight: 500;
        padding-bottom: 20px;
    }
    .ant-card-head {
        border-bottom: none;
        .ant-card-head-title {
            padding: 16px 0 0;
        }
    }
    &-tab {
        background: #ffffff;
        overflow: hidden;
        margin-bottom: 20px;
        position: sticky;
        top: 0px;
        z-index: 9;
        box-shadow: 0 0 7px #cccccc;
        .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
            height: 60px;
        }

        .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
            background: #fff;
            transition: none;
        }

        .ant-tabs-card > .ant-tabs-bar {
            border-color: #fff;
            margin-bottom: 0;
            transition: none;
        }

        .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
            height: 60px;
            border-color: transparent;
            background: transparent;
            transition: none;
            padding-top:8px;

        }
        .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
            border: 0;
            border-top: 3px solid #ff6d33;
            border-radius: 0;
            background: #f8f8f8;
            transition: none;
        }
    }
    .suit-shop {
        margin-bottom: 24px;
        padding-bottom: 1px;
        width: 105%;
        background-color: #f8f8f8;
        position: relative;
        .operat {
            position: absolute;
            right: -64px;
            top: 24px;
        }
    }
}
</style>
